import React, {useState} from 'react';
import {Grid, Card, CardActionArea, CardContent, CardMedia, Divider } from '@material-ui/core/';
import Alert from '@material-ui/lab/Alert';
import Container from '@material-ui/core/Container';
import {useStylesResumen} from './style';

// Redux
import ModalImage from 'components/ImageModal';

function CitizenIdentityDataResumen(props) {
    const classes = useStylesResumen(),
    [verImagen, setVerImagen] = useState(false),
    [datosImagen, setDatosImagen] = useState({image:'', title:'',});

    const VerImagen =(datosImagen)=>{
        setDatosImagen({image: datosImagen.foto, title: datosImagen.tipo})
        setVerImagen(true)
    }
    const CerrarVerImagen =()=>{
        setVerImagen(false)
    }

    return (
        <div>
        { !props.citizenIdentityData[0]?.foto && !props.citizenIdentityData[1]?.foto && !props.citizenIdentityData[2]?.foto && (
            <Container maxWidth="md">
                <Alert variant="outlined" severity="error">
                   NO CUENTA CON REGISTROS DE IMAGENES
                </Alert>
            </Container>
        )}                         
        <Grid container className={classes.rootGrid} justify="center" >
            {props.citizenIdentityData.map((value, index) => (
            <Grid key={index} item>
                <Card className={classes.rootCard} >
                    <CardActionArea>
                        <div className={classes.contentMedia}>
                            <CardMedia
                                className={classes.media}                                
                                alt="image"
                                image={value.foto || "assets/noImagen.svg"}
                                title="image"
                                onClick={()=>VerImagen(value)}
                            />
                        </div>
                        <CardContent  className={classes.cardContent}>
                        <Grid item xs={12}>
                            <div className={classes.centerTitle} onClick={()=>VerImagen(value)}><Divider /> <strong>{value.tipo}</strong> <Divider /></div>
                        </Grid >
                        </CardContent>
                    </CardActionArea>
                </Card>                                    
            </Grid>
            ))}
            <ModalImage base64={datosImagen.image} title={datosImagen.title} open={verImagen} handleClose={CerrarVerImagen}/>
            <div >
            </div>                        
        </Grid>  
 
        </div>  
    );
    }
export default CitizenIdentityDataResumen;